import Layout from "@/views/layout";

const appointmentRouter = {
  path: "/appointment",
  name: "Appointment",
  component: Layout,
  meta: { title: "预约模块" },
  children: [
    {
      path: "detail",
      name: "Detail",
      component: () => import("@/views/appointment/detail"),
      meta: { title: "预约详情" }
    },
    {
      path: "appointmentSetting",
      name: "AppointmentSetting",
      component: () => import("@/views/appointment/appointmentSetting"),
      meta: { title: "预约设置" }
    },
    {
      path: "restSetting",
      name: "RestSetting",
      component: () => import("@/views/appointment/restSetting"),
      meta: { title: "休息设置" }
    }
  ]
};

export default appointmentRouter;
